import * as ko from 'knockout';
import entityBase from 'entityBase';

export class user_role extends entityBase {
    description: KnockoutObservable<string>;
    user_def2  : KnockoutObservable<string>;
    user_def4  : KnockoutObservable<string>;
    user_role  : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.description = ko.observable(item.description).extend({ maxLength: 256 });
        this.user_def2   = ko.observable(item.user_def2).extend({ maxLength: 256 });
        this.user_def4   = ko.observable(item.user_def4).extend({ maxLength: 256 });
        this.user_role   = ko.observable(item.user_role).extend({ maxLength: 32 });
    }
}


